import { APIS } from '@/constants';
import axios from 'axios';

const rolesApi = {
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestList(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      method: 'get',
      baseURL: APIS.BASE_URL.ROLES,
      headers,
    });
  },
};

export default rolesApi;
